import React, {useEffect, useMemo, useState} from "react";
import useCustomTable from "../tables/useCustomTable";
import {Block, Title} from "../components";
import Table from "../tables/Table";
import IabLogo from '../../../assets/images/layout4/iab-logo.png';
import EnabledBadge from "../metrics/tables/cells/EnabledCell";
import {useTranslation} from "react-i18next";
import {Badge, Button, Modal} from "react-bootstrap";
import Icon from "../Icon";
import {PurposeModal} from "./PurposeModal";
import {ExpanderCell} from "../tables/ExpanderCell";

const colorBadgeStyle = {
  "purpose": {
    "backgroundColor": "#ff513c",
    "color": "white"
  },
  "stack": {
    "backgroundColor": "#249661",
    "color": "white"
  },
  "special_feature": {
    "backgroundColor": "#003296",
    "color": "white"
  }
}

const ColoredTick = ({value}) => {
  if (value) {
    return <Icon icon={"checkCircle"} style={{color: "green"}}/>
  } else {
    return <Icon icon={"crossCircle"} style={{color: "red"}}/>
  }
}

export default function Purposes({languages,
                                   addConsentable,
                                   createPurpose,
                                   updatePurpose,
                                   removeConsentable,
                                   params,
                                   purposesLoaderProps,
                                   ...props}) {
  const { t } = useTranslation()

  const [modalPurpose, setModalPurpose] = useState()
  const [showModal, setShowModal] = useState(false)
  const [showCreatePurposeModal, setShowCreatePurposeModal] = useState(false)

  const purposes = useMemo(()=>{
    return props.purposes.map(row => {
      const {purposes: mappedPurposes, specialFeatures, ...otherElements} = row
      return {...row, subRows: [...mappedPurposes, ...specialFeatures]}
    })
  }, [props.purposes])

  const columns = [{
    Cell: ({row}) => {
      if (row.original.iabId) {
        return <img src={IabLogo} style={{height: "24px"}}/>
        return <></>
      } else {
        return <></>
      }
    },
    accessor: 'iabLogo',
    maxWidth: 5,
    minWidth: 5,
    disableSortBy: true
  },{
    id: 'expander',
    Cell: ExpanderCell,
    maxWidth: 2,
    minWidth: 2,
  },{
    Header: 'Name',
    accessor: 'name',
    width: 500,
  },{
    Header: 'Type',
    accessor: 'type',
    width: 50,
    Cell: ({row}) => <Badge style={colorBadgeStyle[row.original.type]}>{t(`cmp.${row.original.type}`).replaceAll(' ', "\n")}</Badge>
  },{
    Header: 'IAB id',
    accessor: 'iabId',
    filter: (rows, columnIds, filterValue) => {
      const columnId = columnIds[0]
      if (filterValue) {
        return rows.filter(row => {
          return filterValue.map(value => {
            return value == !!row.values[columnId]
          }).some(x => x)
        })
      } else {
        return rows
      }
    },
    width: 50
  }, {
    Header: 'Leg. int.',
    accessor: 'legInt',
    Cell: ({row}) => (row.original.type == 'purpose' ? <ColoredTick value={row.original.legInt}/> : ''),
    width: 50
  }, {
    Header: 'Status',
    accessor: 'active',
    Cell: ({row}) => (<EnabledBadge enabled={row.original.active} />),
    width: 50
  }];

  const tableOptions = {
    sortable: false,
    paginate: false,
    filterable: false,
    autoWidth: false
  };

  const {
    tableProps
  } = useCustomTable(tableOptions)

  const showPurpose = (data) => {
    setModalPurpose(data)
    setShowModal(true)
  }

  useEffect(() => {
    !showModal && setModalPurpose(null)
  }, [showModal])

  useEffect(() => {
    modalPurpose && setModalPurpose(purposes.find(el => el.id == modalPurpose.id))
  }, [purposes])

  const purposeModalProps = {
    removeConsentable,
    languages,
    addConsentable,
    updatePurpose,
    params,
    ...purposesLoaderProps
  }

  const onCreate = (data) => {
    createPurpose({...params, purpose: data}).unwrap().then((data) => {
      setShowCreatePurposeModal(false)
      showPurpose({id: data.purposeId})
    })
  }

  return <>
    <Title group={false}>
      <Button onClick={() => setShowCreatePurposeModal(true)}><Icon icon={"plus"}/>{t("cmp.purposes.addPurpose")}</Button>
    </Title>
    <Block>
      <Table
        data={purposes}
        columns={columns}
        onRowClick={showPurpose}
        {...tableProps} />
    </Block>
    <PurposeModal purpose={modalPurpose} show={showModal} setShow={setShowModal} {...purposeModalProps} />
    <PurposeModal show={showCreatePurposeModal} setShow={setShowCreatePurposeModal} editable={true} {...purposeModalProps} onCreate={onCreate}/>
  </>
}
